export const Breadcrumb = {
  parts: ['link'],
  baseStyle: {
    fontFamily: 'body',
    link: {
      color: 'font.primary',
      fontSize: 'sm',
      _hover: {
        textDecoration: 'none',
      },
    },
  },
};
